import { createContext } from "react"

export const PagePropsContext = createContext<unknown>({})
